export const microSticker = {
    enabled: false,
    _description: 'Enables the micro sticker feature on bank card settings page.',
};
